// extracted by mini-css-extract-plugin
export var background = "bv_y";
export var backgroundContainer = "bv_fx";
export var buttons = "bv_cp";
export var container = "bv_h";
export var middleWave = "bv_cV";
export var section = "bv_j";
export var text = "bv_cl";
export var textContainer = "bv_bV";
export var title = "bv_d";